<template>
  <div class="nav-header flex flex-main-justify flex-cross-center">
    <div class="flex h-100">
      <div class="logo-box flex flex-cross-center">
        <img class="logo" src="../assets/img/logo-blue.png" alt="" />
      </div>
      <div class="nav-list flex flex-cross-center h-100">
        <div class="flex flex-cross-center header-content h-100">
          <div
            v-for="item in siteViewList"
            :key="item.id"
            class="cycle flex flex-cross-center"
            :class="{ active: item.id == selectedSiteView }"
            @click="changeSiteView(item.id)"
          >
            <img
              :src="item.id == selectedSiteView ? item.activeUrl : item.url"
              alt=""
            />
            <span>{{ item.value }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="func-box flex flex-main-justify flex-cross-center">
      <div></div>
      <div>
        <img
          src="../assets/img/Icon-kefu.svg"
          class="cp"
          alt=""
          @click="changeContactModalShow(true)"
        />
        <!-- 语言切换 -->
        <!-- <el-select
          v-model="selectedLanguage"
          popper-class="language-select"
          @change="selectLanguage"
          @click.native="hideUserFuncShow"
        >
          <el-option
            v-for="item in languageList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
        <span class="name" @click.stop="changeUserFuncShow">{{
          $store.state.userInfo &&
          $store.state.userInfo.userName
        }}</span>
        <div class="user-func" @click.stop v-show="userFuncShow">
          <p @click="showUserInfo">{{ $t("m.funcUserInfo") }}</p>
          <p @click="showPsdModal">{{ $t("m.funcChangePsd") }}</p>
          <p
            v-if="judgeAuthority('contract_spchannelprovider_get')"
            @click="selectFunc('channel')"
          >
            {{ $t("m.funcManageChannel") }}
          </p>
          <p
            v-if="judgeAuthority('sys_user_list_new')"
            @click="selectFunc('user')"
          >
            {{ $t("m.funcManageUser") }}
          </p>
          <p
            v-if="judgeAuthority('bill_file_list')"
            @click="selectFunc('bill')"
          >
            {{ $t("m.billManage") }}
          </p>
          <p @click="loginOut">{{ $t("m.funcLoginOut") }}</p>
        </div>
      </div>
    </div>
    <!-- 联系我们 -->
    <div class="modal contact-modal" v-show="contactModalShow">
      <div class="modal-body tvac">
        <div class="modal-header flex flex-main-justify flex-cross-center">
          <img src="../assets/img/logo-blue.png" alt="" />
          <i class="el-icon-error" @click="changeContactModalShow(false)"></i>
        </div>
        <div class="tip-box">
          <h4>
            {{ $t("m.allFuncTip") }}
          </h4>
          <p>{{ $t("m.ourContact") }}：info@xrenewable.com</p>
        </div>
        <div class="modal-content">
          <el-input v-model="email" :placeholder="$t('m.email')"></el-input>
          <el-input
            v-model="remark"
            :placeholder="$t('m.remark')"
            type="textarea"
            resize="none"
            :rows="6"
          ></el-input>
          <el-button type="primary" @click="sendEmail">{{
            $t("m.submit")
          }}</el-button>
        </div>
      </div>
    </div>
    <!-- 个人用户信息 -->
    <div class="modal userinfo-modal" v-show="userInfoModalShow">
      <div class="modal-body tvac">
        <div class="modal-header flex flex-main-justify flex-cross-center">
          <h4>{{ $t("m.setUserInfo") }}</h4>
          <i class="el-icon-error" @click="hideUserInfo"></i>
        </div>
        <div class="modal-content">
          <div class="information-one">
            <p>{{ $t("m.userName") }}</p>
            <el-input v-model="username" :disabled="true"></el-input>
          </div>
          <div class="information-one">
            <p>{{ $t("m.userPhone") }}</p>
            <el-input
              v-model="phone"
              :disabled="true"
            ></el-input>
          </div>
          <div class="information-one">
            <p>{{ $t("m.email") }}</p>
            <el-input v-model="remark" :disabled="true"></el-input>
          </div>
          <!-- <el-button type="primary" @click="editUserInfo">{{
            $t("m.setSaveBtn")
          }}</el-button> -->
        </div>
      </div>
    </div>
    <!-- 修改密码 -->
    <div class="modal userinfo-modal" v-show="psdModalShow">
      <div class="modal-body tvac">
        <div class="modal-header flex flex-main-justify flex-cross-center">
          <h4>{{ $t("m.changePsdTitle") }}</h4>
          <i class="el-icon-error" @click="hidePsdModal"></i>
        </div>
        <div class="modal-content">
          <div class="information-one">
            <p>{{ $t("m.originPsd") }}</p>
            <el-input v-model="oldPsd" type="password"></el-input>
          </div>
          <div class="information-one">
            <p>{{ $t("m.newPsd") }}</p>
            <el-input v-model="newPsd" type="password"></el-input>
          </div>
          <div class="information-one">
            <p>{{ $t("m.confirmPsd") }}</p>
            <el-input type="password" v-model="confirmPsd"></el-input>
          </div>
          <el-button type="primary" @click="editPsd">{{
            $t("m.setSaveBtn")
          }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectedSiteView: "1",
      siteViewList: [
        {
          id: "1",
          value: this.$t("m.operations"),
          url: require("../assets/img/top-nav/Operations_B.svg"),
          activeUrl: require("../assets/img/top-nav/Operations.svg"),
        },
        {
          id: "2",
          value: this.$t("m.dashboard"),
          url: require("../assets/img/top-nav/Dashboard_B.svg"),
          activeUrl: require("../assets/img/top-nav/Dashboard.svg"),
        },
        {
          id: "3",
          value: "Statement",
          url: require("../assets/img/top-nav/Statement_B.svg"),
          activeUrl: require("../assets/img/top-nav/Statement.svg"),
        },
      ],
      contactModalShow: false,
      selectedLanguage: "en",
      languageList: [
        {
          value: "zh",
          label: "中文(简体)",
        },
        {
          value: "tc",
          label: "中文(繁體)",
        },
        {
          value: "en",
          label: "English",
        },
      ],
      username: "",
      phone: "",
      remark: "",
      oldPsd: "",
      newPsd: "",
      confirmPsd: "",
      userInfo: {
        roles: [],
      },
      email: "",
      userFuncShow: false,
      userInfoModalShow: false,
      psdModalShow: false,
    };
  },
  created() {
    this.selectedLanguage = this.$store.state.language;
  },
  mounted() {
    document.body.addEventListener("click", this.hideUserFuncShow);
  },
  methods: {
    changeSiteView(id) {
      this.selectedSiteView = id;
      this.$emit("navSelect", id);
    },
    sendEmail() {
      if (!this.email) {
        this.$message.warning(this.$t("m.email") + this.$t("m.emptyTip"));
        return;
      } else if (!this.judgeEmail(this.email)) {
        this.$message.warning(this.$t("m.incorrectTip") + this.$t("m.email"));
        return;
      } else if (!this.remark) {
        this.$message.warning(this.$t("m.remark") + this.$t("m.emptyTip"));
        return;
      }
      this.$http
        .post("/base/dashboard/sendEmail", {
          email: this.email,
          desc: this.remark,
        })
        .then((res) => {
          console.log(res, "email");
          this.$message.success(this.$t("m.savedTip"));
          this.changeContactModalShow(false);
          this.email = "";
          this.remark = "";
        });
    },
    selectFunc(func) {
      this.$emit("selectFunc", func);
      this.changeUserFuncShow();
    },
    selectLanguage() {
      this.$store.commit("updateLanguage", this.selectedLanguage);
      this.$i18n.locale = this.selectedLanguage;
    },
    changeContactModalShow(val) {
      this.contactModalShow = val;
    },
    hideUserFuncShow() {
      if (this.userFuncShow) this.userFuncShow = false;
    },
    changeUserFuncShow() {
      this.userFuncShow = !this.userFuncShow;
    },
    getUserInfo() {
      return this.$http.get("/system/user/" + this.$store.state.userInfo.userId);
    },
    // 显示个人信息
    async showUserInfo() {
      this.userInfo = (await this.getUserInfo()).data;
      delete this.userInfo.password;
      this.username = this.userInfo.userName;
      this.phone = this.userInfo.phonenumber;
      this.remark = this.userInfo.email;
      this.userInfoModalShow = true;
      this.changeUserFuncShow();
    },
    hideUserInfo() {
      this.userInfoModalShow = false;
    },
    // 显示个人信息
    async showPsdModal() {
      this.userInfo = (await this.getUserInfo()).data;
      this.psdModalShow = true;
      this.changeUserFuncShow();
    },
    hidePsdModal() {
      this.psdModalShow = false;
      this.oldPsd = "";
      this.newPsd = "";
      this.confirmPsd = "";
    },
    editUserInfo() {
      if (!this.username) {
        this.emptyTip(this.$t("m.userName"));
      } else if (!this.phone) {
        this.emptyTip(this.$t("m.userPhone"));
      } else {
        this.userInfo.sysUser.username = this.username;
        this.userInfo.sysUser.phone = this.phone;
        this.userInfo.sysUser.jobTitle = this.remark;
        this.userInfo.sysUser.role = this.userInfo.roles;
        this.$http
          .put("/admin/user/update", this.userInfo.sysUser)
          .then((res) => {
            console.log(res, "userinfo");
            this.$message({
              type: "success",
              message: this.$t("m.editTip"),
            });
            this.hideUserInfo();
            this.$store.commit("updateUserInfo", this.userInfo);
          });
      }
    },
    editPsd() {
      if (!this.oldPsd) {
        this.emptyTip(this.$t("m.originPsd"));
      } else if (!this.newPsd) {
        this.emptyTip(this.$t("m.newPsd"));
      } else if (!this.judgePassword(this.newPsd)) {
        this.$message.warning(this.$t("m.passwordErrorTip"));
      } else if (!this.confirmPsd) {
        this.emptyTip(this.$t("m.confirmPsd"));
      } else if (this.newPsd != this.confirmPsd) {
        this.$message({
          type: "warning",
          message: this.$t("m.secondPsdDifferentTip"),
        });
      } else {
        this.$http
          .put("/system/user/profile/updatePwd", {}, {}, {
            oldPassword: this.oldPsd,
            newPassword: this.newPsd,
          })
          .then((res) => {
            console.log(res, "userinfo");
            this.$message({
              type: "success",
              message: this.$t("m.editTip"),
            });
            this.hidePsdModal();
            this.$store.commit("updateUserInfo", this.userInfo);
          });
      }
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/variables.scss";
.language-select {
  background: #fff !important;
  border-color: #a8acb7 !important;
  .el-select-dropdown__item {
    color: $normalColor;
  }
  .popper__arrow::after {
    border-bottom-color: #fff !important;
  }
}
.h-100 {
  height: 100%;
}
.nav-header {
  border-bottom: 1px solid rgba(51, 51, 51, 0.1);
  height: 0.54rem;
  .nav-header-left {
    height: 100%;
  }
  .logo {
    height: 0.4rem;
    padding-left: 0.2rem;
  }
  .nav-list {
    margin-left: 1rem;
  }
  .header-content {
    width: 100%;
    .cycle {
      padding: 0 0.1rem;
      cursor: pointer;
      color: $normalColor;
      margin-left: 0.4rem;
      height: 100%;
      border-radius: 2px;
      span {
        height: 100%;
        line-height: 0.54rem;
        margin-left: 0.1rem;
      }
      &.active {
        position: relative;
        span {
          color: $activeBgColor;
        }
        &::after {
          content: "";
          width: 100%;
          height: 6px;
          background: #00a5df;
          border-radius: 4px;
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
    }
  }
  .func-box {
    height: 100%;
    float: right;
    color: $normalColor;
    font-size: 0.22rem;
    padding-right: 0.2rem;
    position: relative;
    img {
      vertical-align: middle;
    }
    input,
    span {
      color: $normalColor;
    }
    .el-select {
      width: 120px;
      margin-right: 0.2rem;
      .el-input__inner {
        border: none !important;
        padding-right: 0.3rem;
      }
      .el-input__suffix {
        width: 0.3rem;
        color: $normalColor;
        display: flex;
        align-items: center;
        .el-input__suffix-inner {
          display: inline-block;
          width: 100%;
        }
        i {
          color: $normalColor;
        }
      }
    }
    i,
    img {
      margin-right: 0.2rem;
    }
    .name {
      font-size: 0.14rem;
      cursor: pointer;
    }
    .user-func {
      position: absolute;
      bottom: -10px;
      right: 20px;
      transform: translateY(100%);
      background-color: #fff;
      border: 1px solid #a8acb7;
      z-index: 99999;
      width: 160px;
      border-radius: 6px;
      font-size: 0.14rem;
      p {
        line-height: 0.4rem;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  .contact-modal {
    .modal-body {
      width: 6rem;
      background: #fff;
      border-radius: 4px;
      padding: 0;
      box-shadow: 0px 0px 4px 0px rgba(51, 51, 51, 0.1);
      input,
      h4,
      p,
      textarea,
      i,
      span {
        color: $normalColor;
      }
      .modal-header {
        padding: 0 0.4rem;
        height: 0.6rem;
        border-bottom: 0;
        margin-bottom: 0;
        img {
          height: 0.4rem;
        }
        i {
          font-size: 0.3rem;
          cursor: pointer;
          position: relative;
          top: auto;
          left: auto;
          right: auto;
        }
      }
      .tip-box {
        padding: 0.4rem;
        color: #fff;
        transform: translateY(-1px);
        h4 {
          text-align: center;
          margin-bottom: 0.2rem;
        }
        p {
          text-align: center;
        }
      }
      .modal-content {
        padding: 0.4rem;
        .el-textarea {
          margin: 0.3rem 0;
        }
        .el-button {
          width: 100%;
          margin-top: 0.2rem;
          background-color: $activeBgColor;
          span {
            color: #fff;
          }
        }
      }
    }
  }
  .userinfo-modal {
    .modal-body {
      width: 5rem;
      background: #fff;
      padding: 0.24rem 0.4rem;
      border-radius: 4px;
      box-shadow: 0px 0px 4px 0px rgba(51, 51, 51, 0.1);
      input,
      h4,
      span,
      p,
      textarea {
        color: $normalColor;
      }
      .modal-header {
        h4 {
          font-size: 0.34rem;
          margin-top: 0.1rem;
        }
        i {
          font-size: 0.3rem;
          cursor: pointer;
        }
      }
      .information-one {
        margin-top: 0.2rem;
        p {
          margin-bottom: 0.1rem;
        }
      }
      .el-button {
        margin-top: 0.2rem;
        span {
          color: #fff;
        }
      }
      .is-disabled {
        background-color: #eee;
      }
    }
  }
}
</style>
